import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { SketchPicker } from 'react-color';

import CommonTooltip from 'components/common/CommonTooltip';

import './ColorPicker.css';


const ColorPicker = ({ color, onChangeComplete, pickerId, small, mini, disableAlpha }) => {
  const [ popupOpen, setPopupOpen] = useState(true);

  useEffect(() => {
    setPopupOpen(true);
  });

  const _calculateClassName = () => {
    let className = 'color-select-button';
    if (small) { className += ' small'; }
    if (mini) { className += ' mini'; }
    return className;
  };

  return (
    <div className="color-picker__component">
      <div
        data-tip
        data-for={`color-picker-id-${pickerId}`}
        className={_calculateClassName()}
        role="button"
        tabIndex={-1}
        style={color && {
          backgroundColor: `${color}`,
        }}
      >
        <div className="color">{color}</div>
      </div>

      {popupOpen &&
        <CommonTooltip
          id={`color-picker-id-${pickerId}`}
          headerText="Select color"
          onClose={() => setPopupOpen(false)}
        >
          <SketchPicker
            key={`sketch-picker-key-${pickerId}`}
            color={color}
            onChangeComplete={onChangeComplete}
            disableAlpha={disableAlpha}
          />
        </CommonTooltip>
      }
    </div>
  );
};

ColorPicker.propTypes = {
  onChangeComplete: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  pickerId: PropTypes.string.isRequired,
  small: PropTypes.bool,
  disableAlpha: PropTypes.bool,
};

ColorPicker.defaultProps = {
  small: null,
  disableAlpha: false,
};

export default ColorPicker;
